import { CAMINOS_3_CA_ACTIONS } from 'app/store/actions/media/ebooks.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import { EBooksInitialState } from 'app/types/ebooks-reducers.types'

const initialState: EBooksInitialState = {
  data: [],
  loading: true,
  error: false,
}

const Caminos3CA = baseRequestReducer(initialState, CAMINOS_3_CA_ACTIONS)

export default Caminos3CA
